import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `FilesDirective` represent a file of the react uploader.
 * It must be contained in a Uploader component(`UploaderComponent`).
 * ```tsx
 * <UploaderComponent multiple={true}>
 *   <FilesDirective>
 *    <FileDirective name='Java' size=23000 type='pdf'><FileDirective>
 *    <FileDirective name='C++' size=30000 type='.docx'><FileDirective>
 *   </FilesDirective>
 * </UploaderComponent>
 * ```
 */
export class UploadedFilesDirective extends ComplexBase {
}
UploadedFilesDirective.moduleName = 'uploadedFiles';
export class FilesDirective extends ComplexBase {
}
FilesDirective.propertyName = 'files';
FilesDirective.moduleName = 'files';
